export { default } from "./GeneralTableCell";
